// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.Orders_tabContentHeader__1nhdz {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px; }\n  .Orders_tabContentHeader__1nhdz .ant-input-affix-wrapper {\n    max-width: 256px; }\n\n.Orders_pagination__3v3WF {\n  margin-top: 16px; }\n\n.Orders_highlightRow__9_awY {\n  animation: Orders_highlightRow__9_awY 6s 1; }\n\n@keyframes Orders_highlightRow__9_awY {\n  0%,\n  99.95% {\n    background-color: #f8fcff; }\n  100% {\n    background-color: white; } }\n", ""]);
// Exports
exports.locals = {
	"tabContentHeader": "Orders_tabContentHeader__1nhdz",
	"pagination": "Orders_pagination__3v3WF",
	"highlightRow": "Orders_highlightRow__9_awY"
};
module.exports = exports;
